import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout record={props.record[props.side]}>
      <TextField source="season.team.name" />
      <TextField source="id" />
      <TextField source="soccer.id" />
      <TextField source="soccer.firstHalfGoals" />
      <TextField source="soccer.secondHalfGoals" />
      <TextField source="soccer.overtimeGoals" />
      <TextField source="soccer.overtime2Goals" />
      <TextField source="soccer.shootouts" />
      <TextField source="soccer.totalGoals" />
    </SimpleShowLayout>
  );
};

export default Tab;
